var React = require('react');

function Pip (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4","key":0}),React.createElement("rect",{"width":"10","height":"7","x":"12","y":"13","rx":"2","key":1})]);
}

Pip.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-picture-in-picture-2"};

module.exports = Pip;

Pip.default = Pip;
